import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { OrIconComponent, PageLayoutComponent, TitileNavbarComponent } from '@ui-components';
import { COPY_TOKEN, CopyProvider, USER_DATA_TOKEN, UserDataProvider, UserModel } from '@core';
import { map, Observable, switchMap, take } from 'rxjs';

@Component({
  selector: 'lib-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TitileNavbarComponent, PageLayoutComponent, OrIconComponent]
})
export class ReferralComponent {
  private readonly copyProvider: CopyProvider = inject(COPY_TOKEN);
  private readonly userDataProvider: UserDataProvider = inject(USER_DATA_TOKEN);

  private readonly referralCode$: Observable<string> = this.userDataProvider.userData$.pipe(
    map((userData: UserModel) => userData.referralToken)
  );

  readonly referralCode: Signal<string | undefined> = toSignal(this.referralCode$);

  copy(): void {
    this.referralCode$
      .pipe(
        take(1),
        switchMap((code: string) => this.copyProvider.copyToClipboard(code.toUpperCase()))
      )
      .subscribe();
  }
}
